import { Dialog, IconButton, Typography } from '@mui/material';
import { styled } from "@mui/material";
import { ImagePath } from '../../../../assets/ImagePath';

const StyledDialog = styled(Dialog, {
  shouldForwardProp: (prop) =>
    prop !== "customBorderRadius" &&
    prop !== "custompadding" &&
    prop !== "customDialogStyles",
})(({ custompadding, customBorderRadius, customDialogStyles }) => ({
    '& .MuiDialog-paper': {
        ...customDialogStyles,
        padding: custompadding || '50px 30px 50px 55px',
        borderRadius: customBorderRadius || '15px',
    },
}));

const CloseButton = styled(IconButton)(({ theme }) => ({
    position: 'absolute',
    top: theme.spacing(2),
    right: theme.spacing(2),
}));

const HeaderTypography = styled(Typography)(() => ({
    fontFamily: 'Figtree-Bold',
    fontSize: '22px',
    color: '#404585',
    textAlign: 'center',
    marginBottom: '40px',
    marginRight: '15px'
}));

const SubHeaderTypography = styled(Typography)(() => ({
    fontFamily: 'Figtree-Regular',
    fontSize: '16px',
    color: '#727484',
    textAlign: 'center',
    marginTop: '-35px',
    marginRight: '15px'
}));

const EditprofileModal = ({ open, onClose, enableCloseOnOutsideClick = true, custompadding, customDialogStyles = {}, subHeaderContent, customBorderRadius, headerContent, children }) => {
    return (
        <StyledDialog open={open} onClose={enableCloseOnOutsideClick && onClose} custompadding={custompadding} customBorderRadius={customBorderRadius} customDialogStyles={customDialogStyles}>
            <CloseButton onClick={onClose}>
                <img src={ImagePath.closeIcon} width="10px" alt='closeIcon' />
            </CloseButton>
            {headerContent && <HeaderTypography>{headerContent}</HeaderTypography>}
            {subHeaderContent && <SubHeaderTypography>{subHeaderContent}</SubHeaderTypography>}
            {children}
        </StyledDialog>
    );
};

export default EditprofileModal;
